import { getToken } from "@/common/user-token";

export const baseUrl = import.meta.env.VITE_API_BASE_URL
const unauthorisedErrorMessage = "Unauthorised - Please log in first";
const simpleErrorMessage = "There was an issue with the API request";

export async function get(urlPath: string, id?: string | number | boolean) {

    const response = await fetch(`${baseUrl}/${urlPath}${id ? `/${id}` : "" }`, {
        method: 'GET',
        headers: generate_headers()
    });

    if (response.status === 401) {
        throw new Error(unauthorisedErrorMessage);
    } else if (!response.ok) {
        throw new Error(`${simpleErrorMessage}: ${response.status} - ${response.statusText}`);
    }

    return response;
}

export async function put(urlPath: string, body: object) {
    const response = await fetch(`${baseUrl}/${urlPath}`, {
        method: 'PUT',
        body: JSON.stringify(body),
        headers: generate_headers()
    });

    if (response.status === 401) {
        throw new Error(unauthorisedErrorMessage);
    } else if (!response.ok) {
        throw new Error(`${simpleErrorMessage}: ${response.status} - ${response.statusText}`);
    }

    return response;   
}

export async function post(urlPath: string, body: object) {
    const response = await fetch(`${baseUrl}/${urlPath}`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: generate_headers()
    });

    if (response.status === 401) {
        throw new Error(unauthorisedErrorMessage);
    } else if (!response.ok) {
        throw new Error(`${simpleErrorMessage}: ${response.status} - ${response.statusText}`);
    }

    return response;
}

export async function remove(urlPath: string, id?: string | number) {
    const response = await fetch(`${baseUrl}/${urlPath}${id ? `/${id}` : "" }`, {
        method: 'DELETE',
        headers: generate_headers()
    });

    if (response.status === 401) {
        throw new Error(unauthorisedErrorMessage);
    } else if (!response.ok) {
        throw new Error(`${simpleErrorMessage}: ${response.status} - ${response.statusText}`);
    }

    return response;
}


function generate_headers() {
    return {
        'content-type': 'application/json',
        'accept': 'application/json',
        'Authorization': `Bearer ${getToken()}`
    };
}